var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkRequests2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.6065V6.75C18.75 5.0955 17.4045 3.75 15.75 3.75H12.621L14.5605 1.8105L13.5 0.75L9.75 4.5L13.5 8.25L14.5605 7.1895L12.621 5.25H15.75C16.5773 5.25 17.25 5.9235 17.25 6.75V16.6065C15.96 16.9417 15 18.1065 15 19.5C15 21.1545 16.3455 22.5 18 22.5C19.6545 22.5 21 21.1545 21 19.5C21 18.1065 20.04 16.9425 18.75 16.6065ZM18 21C17.1727 21 16.5 20.3272 16.5 19.5C16.5 18.6728 17.1727 18 18 18C18.8273 18 19.5 18.6735 19.5 19.5C19.5 20.3265 18.8273 21 18 21ZM3 4.5C3 5.8935 3.96 7.0575 5.25 7.3935V16.6065C3.96 16.9417 3 18.1065 3 19.5C3 21.1545 4.3455 22.5 6 22.5C7.6545 22.5 9 21.1545 9 19.5C9 18.1057 8.04 16.9425 6.75 16.6065V7.3935C8.04 7.05825 9 5.8935 9 4.5C9 2.8455 7.6545 1.5 6 1.5C4.3455 1.5 3 2.8455 3 4.5ZM7.5 19.5C7.5 20.3272 6.82725 21 6 21C5.17275 21 4.5 20.3272 4.5 19.5C4.5 18.6728 5.17275 18 6 18C6.82725 18 7.5 18.6735 7.5 19.5ZM7.5 4.5C7.5 5.32725 6.82725 6 6 6C5.17275 6 4.5 5.32725 4.5 4.5C4.5 3.67275 5.17275 3 6 3C6.82725 3 7.5 3.67275 7.5 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkRequests2);
export default __webpack_public_path__ + "static/media/network-requests2.1bd91fad16c320345fcbacf9a2a3e1a1.svg";
export { ForwardRef as ReactComponent };